module.exports = __webpack_public_path__ + "static/media/14.87598705.jpg";